export const normalizeProductFingerprint = (product = {}) =>
  [
    product?.category,
    product?.name,
    product?.model,
    product?.brand,
    product?.featureLabel,
    product?.sku,
  ]
    .map((value) => String(value || '').trim().toLowerCase())
    .filter(Boolean)
    .join(' ');

export const resolveProductIconPath = (product = {}) => {
  const fingerprint = normalizeProductFingerprint(product);

  if (/(tecl|keyboard|mec[aá]nic|mouse|perif)/.test(fingerprint)) {
    return 'M3.75 6.75h16.5v10.5H3.75V6.75Zm2.25 2.25v1.5h1.5V9H6Zm2.25 0v1.5h1.5V9h-1.5Zm2.25 0v1.5H12V9h-1.5Zm2.25 0v1.5h1.5V9H12.75Zm2.25 0v1.5h1.5V9h-1.5ZM6 12v1.5h7.5V12H6Zm9 0v1.5h3V12h-3Z';
  }
  if (/(monitor|pantalla|display|tv|smart)/.test(fingerprint)) {
    return 'M4.5 5.25h15a1.5 1.5 0 0 1 1.5 1.5v8.25a1.5 1.5 0 0 1-1.5 1.5h-5.25v1.5h2.25a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5h2.25v-1.5H4.5A1.5 1.5 0 0 1 3 15V6.75a1.5 1.5 0 0 1 1.5-1.5Z';
  }
  if (/(pc|cpu|computadora|notebook|laptop)/.test(fingerprint)) {
    return 'M4.5 4.5h10.5A1.5 1.5 0 0 1 16.5 6v9A1.5 1.5 0 0 1 15 16.5H4.5A1.5 1.5 0 0 1 3 15V6a1.5 1.5 0 0 1 1.5-1.5Zm13.5 3h1.5A1.5 1.5 0 0 1 21 9v6a1.5 1.5 0 0 1-1.5 1.5H18v-9Z';
  }
  if (/(cable|red|ethernet|usb|hdmi|fibra|conector)/.test(fingerprint)) {
    return 'M7.5 3.75A2.25 2.25 0 0 0 5.25 6v2.25H4.5A2.25 2.25 0 0 0 2.25 10.5v3A2.25 2.25 0 0 0 4.5 15.75h3A2.25 2.25 0 0 0 9.75 13.5v-1.125h4.5V13.5A2.25 2.25 0 0 0 16.5 15.75h3a2.25 2.25 0 0 0 2.25-2.25v-3A2.25 2.25 0 0 0 19.5 8.25h-.75V6A2.25 2.25 0 0 0 16.5 3.75h-9Z';
  }
  return 'M4.5 6.75 12 3l7.5 3.75v10.5L12 21l-7.5-3.75V6.75Zm3 2.07v3.93l4.5 2.25 4.5-2.25V8.82L12 6.57 7.5 8.82Z';
};

export const resolveProductIconTone = (product = {}) => {
  const fingerprint = normalizeProductFingerprint(product);
  if (/(tecl|keyboard|mec[aá]nic|mouse|perif)/.test(fingerprint)) {
    return 'border-cyan-300 bg-cyan-100 text-cyan-700';
  }
  if (/(monitor|pantalla|display|tv|smart)/.test(fingerprint)) {
    return 'border-violet-300 bg-violet-100 text-violet-700';
  }
  if (/(pc|cpu|computadora|notebook|laptop)/.test(fingerprint)) {
    return 'border-emerald-300 bg-emerald-100 text-emerald-700';
  }
  if (/(cable|red|ethernet|usb|hdmi|fibra|conector)/.test(fingerprint)) {
    return 'border-amber-300 bg-amber-100 text-amber-700';
  }
  return 'border-slate-300 bg-slate-100 text-slate-700';
};
